import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export default function LoadingSpinner({ size = 'md' }: LoadingSpinnerProps) {
  const { theme } = useTheme();
  
  const sizeStyles = {
    sm: 'h-6 w-6 border-2',
    md: 'h-10 w-10 border-3',
    lg: 'h-16 w-16 border-4'
  };

  return (
    <div className="flex justify-center items-center">
      <div className={`
        animate-spin rounded-full
        ${sizeStyles[size]}
        border-blue-500 border-t-transparent
        ${theme === 'dark' ? 'border-opacity-60' : ''}
      `} />
    </div>
  );
}